<ng-container *ngIf="mark"><span class="dsh-status-icon"></span></ng-container>
<span class="dsh-status-label"><ng-content></ng-content></span>
